import React from 'react';
import { Video } from '@fiverr-private/media';
import { AspectRatioContainer } from '../AspectRatioContainer';

export function InlineVideoPreview({ src, poster, contentType, ...rest }) {
    return (
        <AspectRatioContainer {...rest}>
            <Video
                sources={[{ src, type: contentType }]}
                poster={poster}
                preload="none"
                objectFit="contain"
                width="100%"
                height="100%"
            />
        </AspectRatioContainer>
    );
}
